import styled from '@emotion/styled'

import { Card } from '@/components/Card'
import { CONFIG } from '@/styles/emotion.config'

export const MediaProductGuidesContainer = styled.div`
  max-width: ${CONFIG.maxWidths.md};
  margin-left: auto;
  margin-right: auto;
  padding: 5rem 0;

  ${CONFIG.media.mobileLg} {
    padding: 2.5rem 1rem;
  }
`

export const SectionSummary = styled.div`
  & *:last-child {
    margin-top: 1rem;
  }
`
export const SectionGuides = styled.ol`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-top: 2.5rem;

  ${CONFIG.media.mobileLg} {
    grid-template-columns: repeat(1, 1fr);
    width: 100%;
    align-items: center;
    justify-content: center;
    justify-items: center;
  }
`
export const MediaProductGuideContainer = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  max-width: 17.5rem;
  height: 100%;
`
export const MediaProductGuideSummary = styled.div`
  padding: 1rem;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  a {
    width: 100%;
    margin-top: auto;
  }
`
